import React from 'react';
import { Link } from 'react-router-dom';

const OurClient = () => {
    return (
        <>
            {/* <!-- Breadcromb Area Start --> */}
            <section className="bleezy-breadcromb-area">
                <div className="breadcromb-top section_50">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="breadcromb-top-text">
                                    <h2>Our Clients</h2>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="breadcromb-bottom">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="breadcromb-bottom-text">
                                    <ul>
                                        <li><Link to="/">home</Link></li>
                                        <li><a href="#"><i className="fa fa-long-arrow-right"></i></a></li>
                                        <li>Our Happy Clients</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* <!-- Breadcromb Area End --> */}



            <section class="bleezy-blog-page-area" style={{paddingTop: '15px', paddingBottom: '15px', background: '#ebe6e6' }}>
                <div class="container" style={{width:'100%',marginLeft:'5px', marginRight:'5px'}}>
                    <div class="mid-title text-center  mb-5 "><h2 class="heading-with-border">Our Happy Clients</h2>
                      <div className="our-client-container">
                            <div className="client-card2">
                              <img src='assets/img/OurClients/Client1.jpeg' className='client-img'/>
                            </div>
                            <div className="client-card2">
                              <img src='assets/img/OurClients/Client2.jpeg' className='client-img'/>
                            </div>
                            <div className="client-card2">
                              <img src='assets/img/OurClients/Client3.jpeg' className='client-img'/>
                            </div>
                            <div className="client-card2">
                              <img src='assets/img/OurClients/Client4.jpeg' className='client-img'/>
                            </div>
                            <div className="client-card2">
                              <img src='assets/img/OurClients/Client5.jpeg' className='client-img'/>
                            </div>
                            <div className="client-card2">
                              <img src='assets/img/OurClients/Client6.jpeg' className='client-img'/>
                            </div>
                            <div className="client-card2">
                              <img src='assets/img/OurClients/Client7.jpeg' className='client-img'/>
                            </div>
                            <div className="client-card2">
                              <img src='assets/img/OurClients/Client8.jpeg' className='client-img'/>
                            </div>
                            {/* <div className="client-card2">
                              <img src='assets/img/OurClients/Client9.jpeg' className='client-img'/>
                            </div> */}
                            <div className="client-card2">
                              <img src='assets/img/OurClients/Client10.jpeg' className='client-img'/>
                            </div>
                            <div className="client-card2">
                              <img src='assets/img/OurClients/Client11.jpeg' className='client-img'/>
                            </div>
                            <div className="client-card2">
                              <img src='assets/img/OurClients/Client12.jpeg' className='client-img'/>
                            </div>
                            <div className="client-card2">
                              <img src='assets/img/OurClients/Client13.jpeg' className='client-img'/>
                            </div>
                            <div className="client-card2">
                              <img src='assets/img/OurClients/Client14.jpeg' className='client-img'/>
                            </div>
                            <div className="client-card2">
                              <img src='assets/img/OurClients/Client15.jpeg' className='client-img'/>
                            </div>
                            <div className="client-card2">
                              <img src='assets/img/OurClients/Client16.jpeg' className='client-img'/>
                            </div>
                            <div className="client-card2">
                              <img src='assets/img/OurClients/Client17.jpeg' className='client-img'/>
                            </div>
                            <div className="client-card2">
                              <img src='assets/img/OurClients/Client18.jpeg' className='client-img'/>
                            </div>
                            <div className="client-card2">
                              <img src='assets/img/OurClients/Client19.jpeg' className='client-img'/>
                            </div>
                            <div className="client-card2">
                              <img src='assets/img/OurClients/Client20.jpeg' className='client-img'/>
                            </div>
                            <div className="client-card2">
                              <img src='assets/img/OurClients/Client21.jpeg' className='client-img'/>
                            </div>
                          
                        </div>
                    </div>
                </div>
            </section>


           
        </>
    )
}

export default OurClient;
